class BESSAppProjectEditorInputField extends BESSAppProjectEditorInput {

    constructor(editor, item, field) {
        super(editor, item, field);
        this.changeFn = null;
        this._template = new Template(
            '<div>' +
            '<div class="app-orig-value">' + this.readOnlyDisplayValue + '</div>' +
            this._templateForInput() +
            '</div>');
    }

    containerClass() {
        return 'app-project-editor-input';
    }

    buildView() {
        let node = this._template.build();
        this._configureView(node);
        return node;
    }

    initialise() {
        super.initialise();
        if (this._addChangeHandler() && this.input != null) {
            this.input.onChangeKeyUp(this, this._inputChanged);
        }
    }

    getIntValue(defaultVal) {
        let val = parseInt(this.getValue(defaultVal));
        if (isNaN(val)) {
            return defaultVal;
        }
        return val;
    }

    validate() {
        let result = super.validate();
        if (result === null) {
            if (this.isRequired() && !this.hasValue()) {
                if (this.field.validationError != null) {
                    return this.field.validationError;
                }
                return 'This field is required';
            }
        }
        return result;
    }

    markValid() {
        if (this.input != null || this.input != undefined) {
            this.input.removeAttr('aria-invalid').removeAttr('aria-describedby');
        }
    }

    markInvalid(invalidReasonId) {
        if (this.input != null || this.input != undefined) {
            this.input.attr('aria-invalid', 'true').attr('aria-describedby', invalidReasonId);
        }
    }

    hasValue() {
        let value = this.value.value;
        return value != null && value !== '';
    }

    _getInputValue() {
        let val = this.input.val();
        if(val != null) {
            return this._convertInputValue(val.trim());
        }
        return null;
    }

    _convertInputValue(inputValue) {
        return inputValue;
    }


    setValue(value) {
        super.setValue(value);
        this.input.val(value);
    }

    _configureView(node) {
        let input = node.find('input');
        this.input = input;
        this._configureInput(input);
    }

    _configureInput(input) {
        input.attr('name', this.field.label)
            .attr('value', this.displayValue);

        if (this.field.placeholder) {
            input.attr('placeholder', this.field.placeholder);
        }

        if (this.field.isRequired) {
            input.attr('required', 'required');
        }
    }


    setIsRequired(isRequired) {
        super.setIsRequired(isRequired);
        if (isRequired) {
            this.input.attr('required', 'required');
        } else {
            this.input.removeAttr('required');
        }
    }

    _templateForInput() {
        return '<input class="form-control field-editor app-validation-parent">';
    }

    _toDataValue(value) {
        if (typeof value === 'string' || value instanceof String) {
            return value.trim();
        }
        return value;
    }

    focus() {
        if (this.input) {
            this.input.focus();
        }
        return true;
    }


    _addChangeHandler() {
        return true;
    }
}